import _ from 'lodash'
import {
  TRIGGER_FILTER_CHECKBOX,
  SET_CUSTOMERS_SEARCH_PARAM,
  SET_CUSTOMERS,
  SET_PAGINATED_CUSTOMERS,
} from 'actions'

const initialState = {
  selectedCustomer: null,
  filter: {
    nps: {
      promoter: false,
      detractor: false,
      passive: false,
    },
    searchParam: '',
  },
  allCustomerEmails: [],
  fetchAllCustomersCompleted: false,
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case TRIGGER_FILTER_CHECKBOX: {
      const filterPath = action.filter
      const filterValue = _.get(state.filter, filterPath)
      if (filterValue == null) {
        return state
      }

      const filterObject = _.set({}, filterPath, !filterValue)
      return _.merge({}, state, {
        filter: filterObject,
      })
    }
    case SET_CUSTOMERS_SEARCH_PARAM: {
      return _.merge({}, state, {
        filter: {
          searchParam: action.searchParam.trim().toLowerCase(),
        },
      })
    }
    case SET_CUSTOMERS: {
      const emails = action.customers.map((customer) => customer.email)
      return _.merge({}, state, {
        allCustomerEmails: emails,
        fetchAllCustomersCompleted: true,
      })
    }
    case SET_PAGINATED_CUSTOMERS: {
      return _.merge({}, state, {
        numberOfCustomers: action.numberOfCustomers,
      })
    }
    default:
      return state
  }
}

export default reducer



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/reducers/pages/customer/index.js